export default "__VITE_ASSET__BK3Ev0EN__"